"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostClientAdd = void 0;
const Base_1 = require("./Base");
exports.PostClientAdd = {
    url: Base_1.URL_BASE + "/ClientAdd",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostClientAdd.js.map